export default [
  {
    path: 'codigo-de-resgate/validate',
    name: 'rescue-codes.validate',
    component: () => import(/* webpackChunkName: "rescue-codes" */ './Validate.vue'),
    meta: {
      title: 'Validar Código de Resgate',
      icon: 'mdi-ticket',
    }
  }
];
